import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DkTooltip } from '@dkds/ng-components';

/**
 * HubSpot's sprocket, marking a Request that has a live Linked ticket in HubSpot.
 *
 * It follows `hubspot_linked`, never the Request's `source`: when the link ends the mark goes,
 * though the Request still came from HubSpot. The glyph is Simple Icons' (CC0) in HubSpot's own
 * orange, and its name is spoken, so it never rests on the colour or the shape alone.
 */
@Component({
  selector: 'app-hubspot-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DkTooltip],
  template: `
    <span
      class="hubspot-mark"
      [attr.role]="label() ? 'img' : null"
      [attr.aria-label]="label() || null"
      [attr.aria-hidden]="label() ? null : 'true'"
      [dkTooltip]="label()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" [attr.width]="size()" [attr.height]="size()">
        <path
          fill="currentColor"
          d="M18.164 7.93V5.084a2.198 2.198 0 001.267-1.978v-.067A2.2 2.2 0 0017.238.845h-.067a2.2 2.2 0 00-2.193 2.193v.067a2.196 2.196 0 001.252 1.973l.013.006v2.852a6.22 6.22 0 00-2.969 1.31l.012-.01-7.828-6.095A2.497 2.497 0 104.3 4.656l-.012.006 7.697 5.991a6.176 6.176 0 00-1.038 3.446c0 1.343.425 2.588 1.147 3.607l-.013-.02-2.342 2.343a1.968 1.968 0 00-.58-.095h-.002a2.033 2.033 0 102.033 2.033 1.978 1.978 0 00-.1-.595l.005.014 2.317-2.317a6.247 6.247 0 104.782-11.134l-.036-.005zm-.964 9.378a3.206 3.206 0 113.215-3.207v.002a3.206 3.206 0 01-3.207 3.207z"
        />
      </svg>
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
      flex-shrink: 0;
    }

    .hubspot-mark {
      display: inline-flex;
      align-items: center;
      /* HubSpot's brand orange: a logo, so it keeps the brand's colour rather than a token. */
      color: #ff7a59;
    }
  `,
})
export class HubspotMarkComponent {
  readonly size = input(14);
  /** What the mark says. Empty where the text beside it already names HubSpot: it is then decorative. */
  readonly label = input('Linked to a HubSpot ticket');
}
